import React, { useState } from 'react';
import { generateFullChart, BaZiChart as ChartType } from '../utils/baziCalculator';
import { BaZiChart } from '../components/BaZiChart';
import { ELEMENTS } from '../utils/baziData';
import { motion } from 'framer-motion';
export const PracticalAnalysis: React.FC = () => {
  const [formData, setFormData] = useState({
    year: 1990,
    month: 5,
    day: 15,
    hour: 12,
    gender: 'M' as 'M' | 'F'
  });
  const [chart, setChart] = useState<ChartType | null>(null);
  const handleGenerate = (e: React.FormEvent) => {
    e.preventDefault();
    const result = generateFullChart(formData.year, formData.month, formData.day, formData.hour, formData.gender);
    setChart(result);
  };
  return <div className="space-y-8" data-id="element-250">
      <div className="text-center mb-10" data-id="element-251">
        <h1 className="text-3xl font-serif font-bold text-gold-dark mb-4" data-id="element-252">
          命盘实战分析
        </h1>
        <p className="text-ink-light" data-id="element-253">
          输入公历出生时间，系统将自动推演四柱八字并进行详细解析。
        </p>
      </div>

      <form onSubmit={handleGenerate} className="bg-white ink-border p-6 md:p-8 rounded-lg max-w-3xl mx-auto shadow-sm" data-id="element-254">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-6" data-id="element-255">
          <div data-id="element-256">
            <label className="block text-sm text-gold-dark font-medium mb-2" data-id="element-257">
              年份 (公历)
            </label>
            <input type="number" min="1940" max="2050" required className="w-full bg-paper border border-gold/30 rounded px-3 py-2 text-ink focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold/50 transition-all" value={formData.year} onChange={e => setFormData({
            ...formData,
            year: parseInt(e.target.value)
          })} data-id="element-258" />
          </div>
          <div data-id="element-259">
            <label className="block text-sm text-gold-dark font-medium mb-2" data-id="element-260">
              月份
            </label>
            <input type="number" min="1" max="12" required className="w-full bg-paper border border-gold/30 rounded px-3 py-2 text-ink focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold/50 transition-all" value={formData.month} onChange={e => setFormData({
            ...formData,
            month: parseInt(e.target.value)
          })} data-id="element-261" />
          </div>
          <div data-id="element-262">
            <label className="block text-sm text-gold-dark font-medium mb-2" data-id="element-263">
              日期
            </label>
            <input type="number" min="1" max="31" required className="w-full bg-paper border border-gold/30 rounded px-3 py-2 text-ink focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold/50 transition-all" value={formData.day} onChange={e => setFormData({
            ...formData,
            day: parseInt(e.target.value)
          })} data-id="element-264" />
          </div>
          <div data-id="element-265">
            <label className="block text-sm text-gold-dark font-medium mb-2" data-id="element-266">
              时辰 (0-23)
            </label>
            <input type="number" min="0" max="23" required className="w-full bg-paper border border-gold/30 rounded px-3 py-2 text-ink focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold/50 transition-all" value={formData.hour} onChange={e => setFormData({
            ...formData,
            hour: parseInt(e.target.value)
          })} data-id="element-267" />
          </div>
          <div data-id="element-268">
            <label className="block text-sm text-gold-dark font-medium mb-2" data-id="element-269">
              性别
            </label>
            <select className="w-full bg-paper border border-gold/30 rounded px-3 py-2 text-ink focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold/50 transition-all" value={formData.gender} onChange={e => setFormData({
            ...formData,
            gender: e.target.value as 'M' | 'F'
          })} data-id="element-270">
              <option value="M" data-id="element-271">乾造 (男)</option>
              <option value="F" data-id="element-272">坤造 (女)</option>
            </select>
          </div>
        </div>
        <button type="submit" className="btn-primary w-full text-lg py-3 shadow-md" data-id="element-273">
          生成命盘
        </button>
        <p className="text-xs text-ink-light/70 mt-4 text-center" data-id="element-274">
          注：本系统采用简化节气算法，仅供教学演示使用。
        </p>
      </form>

      {chart && <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="space-y-8" data-id="element-275">
          <section data-id="element-276">
            <h2 className="text-2xl font-serif text-gold-dark mb-6 border-l-4 border-gold pl-3" data-id="element-277">
              四柱排盘
            </h2>
            <BaZiChart chart={chart} showDetails={true} data-id="element-278" />
          </section>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-279">
            <section className="bg-white ink-border p-6 rounded-lg shadow-sm" data-id="element-280">
              <h3 className="text-xl font-serif text-gold-dark mb-6" data-id="element-281">
                五行力量分布
              </h3>
              <div className="space-y-4" data-id="element-282">
                {Object.entries(ELEMENTS).map(([key, el]) => {
              const count = chart.elementCounts[key] || 0;
              const percentage = count / 8 * 100;
              return <div key={key} className="flex items-center gap-4" data-id="element-283">
                      <span className={`w-8 font-bold ${el.color}`} data-id="element-284">
                        {el.name}
                      </span>
                      <div className="flex-1 h-3 bg-paper-dark rounded-full overflow-hidden" data-id="element-285">
                        <motion.div initial={{
                    width: 0
                  }} animate={{
                    width: `${Math.min(percentage, 100)}%`
                  }} transition={{
                    duration: 1
                  }} className="h-full rounded-full" style={{
                    backgroundColor: `var(--color-element-${key})`
                  }} data-id="element-286" />
                      </div>
                      <span className="w-8 text-right text-sm text-ink-light font-medium" data-id="element-287">
                        {count}
                      </span>
                    </div>;
            })}
              </div>
              <p className="text-sm text-ink-light mt-6 leading-relaxed bg-paper p-3 rounded" data-id="element-288">
                日主为{' '}
                <strong className="text-gold-dark" data-id="element-289">
                  {chart.dayMaster.name}
                  {ELEMENTS[chart.dayMaster.element].name}
                </strong>
                。
                {chart.elementCounts[chart.dayMaster.element] >= 3 ? '日主得势，身偏旺。' : '日主失势，身偏弱。'}
                (注：此为基础数量判断，实际需结合月令综合考量)
              </p>
            </section>

            <section className="bg-white ink-border p-6 rounded-lg space-y-6 shadow-sm" data-id="element-290">
              <div data-id="element-291">
                <h3 className="text-lg font-serif text-gold-dark mb-2" data-id="element-292">
                  空亡分析
                </h3>
                <p className="text-ink-light bg-paper p-2 rounded text-sm" data-id="element-293">
                  日柱所在旬空亡为：
                  <strong className="text-cinnabar" data-id="element-294">
                    {chart.voidBranches.join('、')}
                  </strong>
                </p>
              </div>

              <div data-id="element-295">
                <h3 className="text-lg font-serif text-gold-dark mb-2" data-id="element-296">
                  日柱自坐
                </h3>
                <p className="text-ink-light leading-relaxed text-sm bg-paper p-3 rounded" data-id="element-297">
                  日柱{' '}
                  <strong data-id="element-298">
                    {chart.day.stem.name}
                    {chart.day.branch.name}
                  </strong>
                  ， 自坐{' '}
                  <strong className="text-gold-dark" data-id="element-299">
                    {chart.day.shiShen}
                  </strong>
                  。<br data-id="element-300" />
                  {chart.day.shiShen === '正财' || chart.day.shiShen === '偏财' ? '配偶多有助力，重视现实物质。' : ''}
                  {chart.day.shiShen === '正官' || chart.day.shiShen === '七杀' ? '配偶多有威严，自我约束力强。' : ''}
                  {chart.day.shiShen === '正印' || chart.day.shiShen === '偏印' ? '配偶多包容，思想较为主观。' : ''}
                  {chart.day.shiShen === '比肩' || chart.day.shiShen === '劫财' ? '配偶如朋友，有时易生口角。' : ''}
                  {chart.day.shiShen === '食神' || chart.day.shiShen === '伤官' ? '配偶多才华，注重精神交流。' : ''}
                </p>
              </div>

              <div data-id="element-301">
                <h3 className="text-lg font-serif text-gold-dark mb-3" data-id="element-302">
                  命局神煞
                </h3>
                <div className="flex flex-wrap gap-2" data-id="element-303">
                  {[...new Set([...chart.year.shenSha, ...chart.month.shenSha, ...chart.day.shenSha, ...chart.hour.shenSha])].map((ss, i) => <span key={i} className="px-3 py-1 bg-white border border-gold/40 rounded-full text-sm text-gold-dark shadow-sm font-medium" data-id="element-304">
                      {ss}
                    </span>)}
                  {![...chart.year.shenSha, ...chart.month.shenSha, ...chart.day.shenSha, ...chart.hour.shenSha].length && <span className="text-ink-light text-sm" data-id="element-305">无特殊神煞</span>}
                </div>
              </div>
            </section>
          </div>
        </motion.div>}
    </div>;
};